/*
  Header dinâmico (home):
  - .header-wrapper--past-hero: quando o scroll passa da primeira seção (hero/slides)
    → troca a logo para a versão dark e recolore menu/ícones para #222F28.
  - .header-wrapper--over-dark: quando o header está sobre uma seção escura
    (marcada com data-header-dark) → força a versão clara (logo clara + menu branco),
    mesmo depois do hero. Isso resolve o contraste sobre seções escuras (Comunidade, Marquee).
  - .header-wrapper--over-light: quando o header está SOBRE O BANNER e a arte
    atrás dele é clara → mesma inversão do --past-hero, antes de sair do hero.
    E o botão do slide ganha `--sobre-claro` pelo mesmo critério, medido na
    região dele. Ver o bloco TOM DA ARTE lá embaixo.
*/
(function () {
  function init() {
    var header = document.querySelector('.header-wrapper--glass');
    if (!header) return;

    var main = document.getElementById('MainContent') || document.querySelector('main');
    var firstSection = main && main.querySelector('.shopify-section');

    var headerHeight = Math.round(header.offsetHeight) || 90;

    /* ----- past-hero: logo dark após a 1ª seção ----- */
    if (firstSection && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          header.classList.toggle('header-wrapper--past-hero', !entries[0].isIntersecting);
        },
        { rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 }
      );
      observer.observe(firstSection);
    }

    /* ----- over-light: header escuro sobre arte clara do banner ----- */
    /* Vem ANTES do `over-dark`, que tem um `return` quando nao ha secao escura
       na pagina -- chamado depois, o tom da arte nunca ligaria numa pagina sem
       secao escura, que e justamente a home de hoje. */
    iniciarTomDaArte(header);

    /* ----- over-dark: header claro sobre seções escuras ----- */
    var darkSections = Array.prototype.slice.call(
      document.querySelectorAll('[data-header-dark]')
    );
    if (!darkSections.length) return;

    var probeY = headerHeight / 2;
    var ticking = false;

    function updateOverDark() {
      ticking = false;
      var over = false;
      for (var i = 0; i < darkSections.length; i++) {
        var r = darkSections[i].getBoundingClientRect();
        if (r.top <= probeY && r.bottom >= probeY) {
          over = true;
          break;
        }
      }
      header.classList.toggle('header-wrapper--over-dark', over);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateOverDark);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      headerHeight = Math.round(header.offsetHeight) || headerHeight;
      probeY = headerHeight / 2;
      updateOverDark();
    });
    updateOverDark();
  }


  /* ======================================================================
     TOM DA ARTE DO BANNER (04/09/2026)

     O --past-hero nasceu para o instante em que o header DEIXA o hero. Sobre o
     hero ele fica branco de proposito -- os banners eram video e foto escura.
     Com arte promocional branca, texto branco sobre 228 de brilho da ~1,1:1 de
     contraste: nao e pouco legivel, nao existe na tela. O mesmo vale para o
     botao `--glass`, que e branco translucido de borda branca.

     Entao aqui a arte e MEDIDA e o header decide sozinho. Duas regioes, porque
     elas discordam: no PROMO_0409-3 o topo tem brilho 228 (claro) e o canto
     inferior esquerdo 139 (medio). Uma resposta so para o slide inteiro estaria
     errada em uma das duas pontas.

     COMO A MEDICAO ACERTA A REGIAO
     A imagem e `object-fit: cover`, ou seja RECORTADA: o pixel que esta atras do
     header na tela nao e o pixel da mesma proporcao no arquivo. Sem desfazer o
     cover, mediria o lugar errado -- e num banner 1920x986 exibido em 375px de
     largura o erro e a imagem quase toda. `regiao()` inverte o cover (escala
     pelo lado que sobra, centralizado, que e o `object-position: center` do CSS)
     e devolve as coordenadas no arquivo.

     POR QUE `crossOrigin` E UMA IMAGEM NOVA
     Canvas com imagem de outro dominio fica "tainted" e `getImageData` lanca.
     O CDN da Shopify manda `access-control-allow-origin: *` (conferido), entao
     recarregar a MESMA url com `crossOrigin = 'anonymous'` da um canvas limpo --
     e sai do cache do navegador, sem download novo. A imagem da pagina nao
     serve: ela foi carregada sem o atributo.

     TUDO FALHA PARA O LADO SEGURO. Sem canvas, sem CORS, imagem nao decodificada
     ou medicao com erro: nenhuma classe entra e o comportamento e exatamente o
     de antes.
     ====================================================================== */
  var LIMIAR_CLARO = 150; // 0=preto, 255=branco. Acima disto, texto branco morre.
  var cacheBrilho = {};

  /* ======================================================================
     O QUE SE MEDE E O TOM DOMINANTE DA REGIAO: A MEDIA.

     Isto ja foi percentil 75 por algumas horas, e a troca foi remedio para um
     diagnostico errado -- fica registrado para ninguem repetir.

     O botao aparecia branco sobre a arte clara no desktop. Eu fui medir a arte
     na mao para entender, e medi o canto inferior ESQUERDO, onde esta a foto da
     modelo: media 130, abaixo do limiar. Conclui que a media era o problema
     ("metade branca, metade escura, media da cinza") e troquei para o percentil
     75, que enxerga a parte clara.

     O botao fica no canto inferior DIREITO. Medido no lugar certo, a arte clara
     da media 250 -- nunca houve ambiguidade. A causa real do botao branco era
     outra: `imagemDoSlide` pegava a arte de CELULAR, que continua com
     `naturalWidth` mesmo escondida por `display: none`.

     E o percentil cobrou o preco na arte da selva. Folhagem verde tem
     luminancia alta (o verde pesa 0,587 na formula), entao 36% dos pixels
     passam de 150 numa foto que le como escura: p75 = 159, nove pontos acima do
     limiar, e o botao escurecia sobre fundo escuro.

     Medido na regiao real do botao, nas duas artes:

       PROMO_0409-3 (clara)    media 250   p50 250   p75 250
       desk_final-01 (selva)   media 113   p50 140   p75 159

     A media separa por 137 pontos; o p75 por 91, com margem de 9 do lado que
     importa. A media tambem e a que acompanha a percepcao: a selva LE como
     escura, e 113 diz isso.
     ====================================================================== */
  function brilhoMedio(dados) {
    var s = 0;
    for (var i = 0; i < dados.length; i += 4) {
      s += 0.299 * dados[i] + 0.587 * dados[i + 1] + 0.114 * dados[i + 2];
    }
    return s / (dados.length / 4);
  }

  /* Converte um retangulo da TELA para coordenadas do ARQUIVO, desfazendo o
     `object-fit: cover` centralizado. Devolve null se nao houver interseccao.

     ESTA FUNCAO JA FOI APAGADA POR ENGANO UMA VEZ (04/09/2026). Ao trocar a
     metrica de brilho, o recorte foi do comentario da metrica ate o comentario
     do `medir` -- e ela morava exatamente no meio desse intervalo. O arquivo
     continuou com sintaxe valida, `node --check` passou, e o unico sintoma foi
     `medir` lancar ReferenceError em silencio dentro do try/catch, que devolvia
     'sujo' e depois desistia. O header ficou branco sobre banner branco na loja
     publicada por horas sem nenhum erro no console.

     Se for mexer aqui: ela e usada por `medir`, que esta logo abaixo. */
  function regiao(img, caixa, rect) {
    var W = img.naturalWidth, H = img.naturalHeight;
    if (!W || !H || !rect.width || !rect.height) return null;

    var escala = Math.max(rect.width / W, rect.height / H);
    var visW = rect.width / escala, visH = rect.height / escala;
    var offX = (W - visW) / 2, offY = (H - visH) / 2;

    var e = Math.max(caixa.left, rect.left), d = Math.min(caixa.right, rect.right);
    var t = Math.max(caixa.top, rect.top), b = Math.min(caixa.bottom, rect.bottom);
    if (d <= e || b <= t) return null;

    return {
      x: offX + (e - rect.left) / escala,
      y: offY + (t - rect.top) / escala,
      w: (d - e) / escala,
      h: (b - t) / escala
    };
  }

  /* Devolve o brilho, ou 'sujo' se o canvas estiver contaminado, ou null se a
     regiao nem existe. Distinguir os dois casos e o que permite tentar a copia
     CORS so quando ela e de fato necessaria. */
  function medir(src, img, caixa, rect, chave) {
    var ck = chave + '|' + src + '|' + Math.round(caixa.top) + ',' + Math.round(caixa.left) +
             ',' + Math.round(caixa.width) + ',' + Math.round(caixa.height) +
             ',' + Math.round(rect.width) + 'x' + Math.round(rect.height);
    if (ck in cacheBrilho) return cacheBrilho[ck];

    var r = regiao(img, caixa, rect);
    if (!r) return null;
    try {
      var c = document.createElement('canvas');
      c.width = 24; c.height = 24;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, r.x, r.y, r.w, r.h, 0, 0, 24, 24);
      var v = brilhoMedio(ctx.getImageData(0, 0, 24, 24).data);
      cacheBrilho[ck] = v;
      return v;
    } catch (e) {
      /* SO o canvas contaminado e esperado aqui, e ele tem plano B. Qualquer
         outro erro e defeito de codigo, e engoli-lo foi o que deixou a funcao
         `regiao` apagada passar despercebida por horas: `medir` devolvia 'sujo',
         a copia CORS tambem falhava, e nada aparecia no console.

         `SecurityError` e o nome que os navegadores dao ao canvas sujo. O resto
         sobe. */
      if (e && e.name === 'SecurityError') return 'sujo';
      throw e;
    }
  }

  /* A IMAGEM DA PROPRIA PAGINA VEM PRIMEIRO, e a copia CORS e o plano B.

     Era o contrario, e nao funcionava: eu recarregava a url com
     `crossOrigin = 'anonymous'` sempre, e marcava o src como 'falhou' no
     primeiro erro, para sempre. Quando o `<img>` da pagina ainda esta em VOO sem
     CORS, o navegador coalesce a minha requisicao com aquela, a validacao de
     CORS falha na resposta sem cabecalho, e o `onerror` dispara -- na primeira
     tentativa, que era justamente a do carregamento. Dali em diante o src estava
     na lista negra e nenhuma medicao acontecia mais, sem erro no console, porque
     tudo falha para o lado seguro.

     Comecar pela imagem da pagina resolve por baixo: se o canvas nao estiver
     contaminado (o CDN da Shopify manda `access-control-allow-origin: *`), a
     medicao sai na hora, sem requisicao nenhuma e sem depender de ordem de
     carregamento. So se der taint e que a copia CORS entra -- e ela nao vira
     lista negra: erra, espera o proximo evento e tenta de novo, no maximo tres
     vezes por src. */
  var copias = {};
  var falhas = {};
  function copiaCors(src, cb) {
    if (copias[src]) { if (copias[src].complete) cb(copias[src]); return; }
    if ((falhas[src] || 0) >= 3) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { copias[src] = im; cb(im); };
    im.onerror = function () {
      falhas[src] = (falhas[src] || 0) + 1;
      copias[src] = null;
    };
    copias[src] = im;
    im.src = src;
  }

  /* ======================================================================
     QUAL IMAGEM ESTA ATRAS DE UMA CAIXA

     Duas regras diferentes, porque as duas perguntas sao diferentes -- e
     confundi-las foi a causa do comportamento errado no carrossel.

     PARA O HEADER: o PONTO CENTRAL da caixa dele. O header nao se move com o
     carrossel; o que passa por tras dele muda. Num instante qualquer, o pixel
     atras daquele ponto pertence a UM slide -- nunca a dois. A versao anterior
     escolhia por MAIOR AREA SOBREPOSTA, e no meio da transicao as duas artes
     cobrem pedacos da caixa: a resposta pulava de uma para a outra conforme a
     animacao andava.

     PARA O BOTAO: a imagem do PROPRIO slide dele, sempre. O botao viaja junto
     com a arte, entao o fundo dele nunca muda -- perguntar "o que esta atras
     deste botao agora" era transformar uma resposta fixa em algo que dependia
     da posicao da animacao. Por isso ele piscava.

     O clone borrado do degrade fica de fora: e a mesma arte de novo, e escolhe-lo
     nao muda a medida, mas suja a leitura de quem for depurar isto depois.
     ====================================================================== */
  function ehArte(img) {
    return !/degrade-blur-image/.test(img.className || '');
  }

  /* ======================================================================
     SLIDE EM VIDEO (03/11/2026)

     A medicao so olhava `<img>`. Quando o 1o slide virou video (Black da Blumi,
     arte creme), nada era medido e o header e o botao ficaram brancos sobre
     fundo claro.

     O quadro do video em si nao serve: o arquivo vem do CDN de video, e
     desenhar video de outro dominio no canvas suja o canvas. O que se mede e o
     POSTER -- o primeiro quadro, que a Shopify serve como imagem comum do CDN
     da loja (com `access-control-allow-origin: *`). Nos banners que vieram de
     GIF o fundo e o mesmo em todos os quadros, entao o primeiro responde pelo
     video inteiro.

     Cada "arte" agora e um par: `el`, o elemento NA TELA (de onde sai o
     retangulo do cover), e `img`, o bitmap medido. Para `<img>` os dois sao o
     mesmo elemento. Poster ainda nao baixado = sem medida (lado seguro); o laco
     por quadro mede de novo quando ele chegar.
     ====================================================================== */
  var posters = {};
  function quadroDoVideo(v) {
    var src = v.getAttribute('poster');
    if (!src) return null;
    var p = posters[src];
    if (!p) {
      p = new Image();
      p.crossOrigin = 'anonymous';
      p.src = src;
      posters[src] = p;
    }
    return p.complete && p.naturalWidth ? p : null;
  }

  function arteDe(el) {
    if (!ehArte(el)) return null;
    var bitmap = el.tagName === 'VIDEO' ? quadroDoVideo(el) : el;
    if (!bitmap || !bitmap.naturalWidth) return null;
    return { el: el, img: bitmap };
  }

  function imagemNoPonto(secao, x, y) {
    var els = secao.querySelectorAll('img, video');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width) continue;
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) continue;
      var arte = arteDe(els[i]);
      if (arte) return arte;
    }
    return null;
  }

  /* A imagem do slide tem de estar RENDERIZADA, nao apenas carregada -- e essa
     distincao era o defeito no desktop.

     Cada slide carrega DUAS artes, a de celular e a de desktop, e o CSS esconde
     a que nao serve para a largura atual. Imagem em `display: none` continua
     com `naturalWidth` depois de baixada, entao "esta carregada?" nao distingue
     as duas: eu pegava a PRIMEIRA da lista, que e a de celular, e no desktop
     media a arte errada. O botao ficava claro sobre fundo claro porque a arte de
     celular e escura naquele ponto.

     O header nunca teve o problema porque `imagemNoPonto` exige caixa com
     largura -- e caixa de largura zero e exatamente o que `display: none`
     produz. Era a mesma verificacao faltando aqui.

     Entre as candidatas visiveis, a de maior sobreposicao com a caixa: no
     desktop e uma so, mas se um dia houver arte dividida em duas, ganha a que
     esta de fato atras do botao. */
  function imagemDoSlide(el, caixa) {
    var slide = el.closest ? el.closest('.swiper-slide') : null;
    if (!slide) return null;
    var els = slide.querySelectorAll('img, video');
    var melhor = null, maior = -1;
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      var arte = arteDe(els[i]);
      if (!arte) continue;
      var w = Math.min(caixa.right, r.right) - Math.max(caixa.left, r.left);
      var h = Math.min(caixa.bottom, r.bottom) - Math.max(caixa.top, r.top);
      var a = w > 0 && h > 0 ? w * h : 0;
      if (a > maior) { maior = a; melhor = arte; }
    }
    return melhor;
  }

  function iniciarTomDaArte(header) {
    var secao = document.querySelector('[class*="tp-e-banner-slides-v1"]');
    if (!secao) return;
    if (!document.createElement('canvas').getContext) return;

    var pendente = false;

    /* Mede o brilho da `arte` ({el, img}) na regiao da `caixa` e chama `cb(claro)`.
       Nao faz nada se nao conseguir medir -- e o `cb` nunca recebe um palpite. */
    function tom(arte, caixa, chave, cb) {
      if (!arte) return;
      var img = arte.img;
      var src = img.currentSrc || img.src;
      if (!src) return;
      var rect = arte.el.getBoundingClientRect();
      if (!rect.width || !img.naturalWidth) return;

      var b = medir(src, img, caixa, rect, chave);
      if (b === 'sujo') {
        copiaCors(src, function (limpa) {
          var b2 = medir(src, limpa, caixa, rect, chave);
          if (b2 !== null && b2 !== 'sujo') cb(b2 > LIMIAR_CLARO);
        });
        return;
      }
      if (b !== null) cb(b > LIMIAR_CLARO);
    }

    function aplicar() {
      pendente = false;

      var cx = header.getBoundingClientRect();
      var arte = secao.getBoundingClientRect();

      /* O header so consulta a arte enquanto esta EM CIMA dela. Passando disso,
         quem manda e o --past-hero e o --over-dark, que ja resolvem o resto da
         pagina -- e insistir aqui faria os tres estados disputarem a cor. */
      if (cx.bottom > arte.top && cx.top < arte.bottom) {
        var meioX = (cx.left + cx.right) / 2;
        var meioY = (cx.top + cx.bottom) / 2;
        tom(imagemNoPonto(secao, meioX, meioY), cx, 'topo', function (claro) {
          header.classList.toggle('header-wrapper--over-light', claro);
        });
      } else {
        header.classList.remove('header-wrapper--over-light');
      }

      var btns = secao.querySelectorAll('.tp-e-banner-slides-v1__button');
      Array.prototype.forEach.call(btns, function (btn) {
        var cb = btn.getBoundingClientRect();
        if (!cb.width) return;
        tom(imagemDoSlide(btn, cb), cb, 'btn', function (claro) {
          btn.classList.toggle('tp-e-banner-slides-v1__button--sobre-claro', claro);
        });
      });
    }

    /* rAF NAO DISPARA EM ABA OCULTA, e uma pagina aberta em nova aba nasce
       oculta -- a primeira medicao simplesmente nunca acontecia ali. O
       `setTimeout` cobre o caso oculto; o rAF continua sendo o caminho normal,
       porque e ele que junta a medicao com a pintura durante a rolagem. */
    function agendar() {
      if (pendente) return;
      pendente = true;
      if (document.hidden) window.setTimeout(aplicar, 0);
      else window.requestAnimationFrame(aplicar);
    }

    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar);
    window.addEventListener('load', agendar);
    document.addEventListener('visibilitychange', agendar);

    /* ------------------------------------------------------------------
       REAMOSTRAR ATE ASSENTAR -- o que faltava, e a causa do estado travado.

       O Swiper anima por `transform` no `style` da `.swiper-wrapper`. O
       MutationObserver anterior olhava `class`, `src` e `srcset`, e nenhuma
       dessas muda durante a animacao: eu media UMA vez, no comeco da troca,
       quando o slide que entra ainda esta fora de posicao -- e nunca mais.
       Dai o comportamento que voce viu: entra no banner escuro e fica escuro,
       ou clareia no meio do caminho e trava assim ao voltar.

       `transitionend` no proprio elemento animado resolve o caso normal;
       observar `style` pega quem muda o transform sem transicao; e o intervalo
       curto e a rede para carrossel com autoplay, arraste do dedo e qualquer
       animacao por JS que nao emita evento nenhum.

       O intervalo e barato: duas leituras de retangulo e um acerto de cache.
       As medidas ficam memorizadas por (src + regiao), entao o trabalho de
       canvas acontece uma vez por combinacao, nao a cada 250ms. E ele so roda
       enquanto o banner esta na tela.
       ------------------------------------------------------------------ */
    secao.addEventListener('transitionend', agendar, true);

    if (window.MutationObserver) {
      new MutationObserver(agendar).observe(secao, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'srcset', 'style']
      });
    }

    /* ------------------------------------------------------------------
       ENQUANTO O BANNER ESTA NA TELA, ACOMPANHA QUADRO A QUADRO.

       Comecou como um intervalo de 250ms, e 250ms e visivel: no meio de uma
       troca de slide o header ficaria com a cor da arte anterior por um quarto
       de segundo, o que le como piscada -- justamente o que se quer evitar.

       Em rAF ele acompanha a animacao do carrossel de verdade: a cor vira no
       mesmo quadro em que a arte passa pelo centro do header. E e barato porque
       o trabalho por quadro e duas leituras de retangulo e um acerto de cache --
       a medida de canvas acontece uma vez por (src + regiao) e fica memorizada.

       O laco existe SO enquanto o banner intersecta a viewport, e para sozinho
       quando ele sai. Com a aba oculta cai para , porque rAF nao
       dispara ali (mesma razao do ).
       ------------------------------------------------------------------ */
    var laco = null;
    var relogio = null;

    function quadro() {
      if (laco === null) return;
      aplicar();
      laco = window.requestAnimationFrame(quadro);
    }

    function vigiar() {
      var r = secao.getBoundingClientRect();
      var naTela = r.bottom > 0 && r.top < window.innerHeight;

      if (naTela) {
        if (document.hidden) {
          if (laco !== null) { window.cancelAnimationFrame(laco); laco = null; }
          if (!relogio) relogio = window.setInterval(agendar, 250);
        } else {
          if (relogio) { window.clearInterval(relogio); relogio = null; }
          if (laco === null) { laco = 0; laco = window.requestAnimationFrame(quadro); }
        }
      } else {
        if (laco !== null) { window.cancelAnimationFrame(laco); laco = null; }
        if (relogio) { window.clearInterval(relogio); relogio = null; }
      }
    }
    document.addEventListener('visibilitychange', vigiar);
    window.addEventListener('scroll', vigiar, { passive: true });
    window.addEventListener('resize', vigiar);
    vigiar();

    agendar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
